
export const onSecondaryBackgroundRounded = { background: 'var(--tertiary-background-color)', borderRadius: '8px'};


